class ExclusiveProductGuard {
  constructor() {
    this.#init();
  }

  #init() {
    const cleanupContainer = document.querySelector('[data-exclusive-cleanup]');

    if (cleanupContainer) {
      this.#runCleanup(cleanupContainer);
    } else {
      this.#maybeShowBanner();
    }
  }

  #runCleanup(container) {
    const keys = container.dataset.exclusiveCleanup.split(',').filter(Boolean);
    if (!keys.length) return;

    const checkoutBtn = document.getElementById('checkout-btn');
    if (checkoutBtn) {
      checkoutBtn.disabled = true;
      checkoutBtn.style.pointerEvents = 'none';
      checkoutBtn.style.opacity = '0.5';
    }

    const updates = {};

    for (const key of keys) {
      updates[key] = 0;
    }

    fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ updates })
    })
      .then(() => {
        sessionStorage.setItem('exclusiveCleanupDone', 'true');
        window.location.reload();
      })
      .catch(console.error);
  }

  #maybeShowBanner() {
    if (sessionStorage.getItem('exclusiveCleanupDone') !== 'true') return;

    sessionStorage.removeItem('exclusiveCleanupDone');

    const banner = document.querySelector('[data-exclusive-cleanup-banner]');
    if (banner) banner.removeAttribute('hidden');
  }
}

document.addEventListener('DOMContentLoaded', () => new ExclusiveProductGuard());
